import { cn } from "@portal/components/lib/utils";
import type { FC } from "react";
import type { Severity } from "./types";

const severityColor: Record<Severity, string> = {
	warn: "bg-warning",
	info: "bg-intent-info-text",
};

export const SeverityDot: FC<{ severity: Severity }> = ({ severity }) => (
	<div className={cn("size-2 shrink-0 rounded-full", severityColor[severity])} aria-hidden />
);
